import { ProjectPage } from "pages/ProjectPage/ProjectPage";

export default ProjectPage;
